var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "card",
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c(
                    "div",
                    { staticClass: "left-bar" },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("客户品种数量统计分析"),
                      ]),
                      _c("DatePicker", {
                        staticStyle: { "margin-left": "4px", width: "200px" },
                        attrs: {
                          type: "daterange",
                          size: "small",
                          transfer: "",
                          placement: "bottom-end",
                          placeholder: "选择期初和期末时间",
                        },
                        on: { "on-change": _vm.onDateChange },
                        model: {
                          value: _vm.selectDates,
                          callback: function ($$v) {
                            _vm.selectDates = $$v
                          },
                          expression: "selectDates",
                        },
                      }),
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "200px", "margin-left": "5px" },
                          attrs: {
                            size: "small",
                            placeholder: "选择客户",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.userExternalCustomerLoginUuid,
                            callback: function ($$v) {
                              _vm.userExternalCustomerLoginUuid = $$v
                            },
                            expression: "userExternalCustomerLoginUuid",
                          },
                        },
                        _vm._l(_vm.userList, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.userExternalCustomerLoginUuid,
                              attrs: {
                                value: item.userExternalCustomerLoginUuid,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.userName +
                                    "-" +
                                    item.userExternalCustomerName
                                )
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "RadioGroup",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: { type: "button", size: "small" },
                          model: {
                            value: _vm.subGroupBy,
                            callback: function ($$v) {
                              _vm.subGroupBy = $$v
                            },
                            expression: "subGroupBy",
                          },
                        },
                        [
                          _c("Radio", { attrs: { label: "mainCate" } }, [
                            _c("span", [_vm._v("大类")]),
                          ]),
                          _c("Radio", { attrs: { label: "subCate" } }, [
                            _c("span", [_vm._v("小类")]),
                          ]),
                          _c("Radio", { attrs: { label: "commodity" } }, [
                            _c("span", [_vm._v("商品")]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "success",
                            size: "small",
                            icon: "ios-stats",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.beginStat()
                            },
                          },
                        },
                        [_vm._v("统计")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("Table", {
                    ref: "mainTable",
                    attrs: {
                      columns: _vm.mainTable.columns,
                      size: "small",
                      data: _vm.mainTable.data,
                      loading: _vm.mainTable.loading,
                      height: _vm.mainTable.tableHeight,
                      stripe: "",
                      border: "",
                    },
                  }),
                  _c(
                    "Modal",
                    {
                      attrs: { width: 1000, "footer-hide": "" },
                      model: {
                        value: _vm.customerQantityProductModal.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.customerQantityProductModal, "show", $$v)
                        },
                        expression: "customerQantityProductModal.show",
                      },
                    },
                    [
                      _vm.customerQantityProductModal.innerSpin
                        ? _c("Spin", { attrs: { size: "large", fix: "" } })
                        : _vm._e(),
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "font-size": "14px",
                            },
                          },
                          [_vm._v("客户品种数量统计")]
                        ),
                      ]),
                      _c("CustomerStatBar", {
                        ref: "customerStatBar",
                        staticStyle: { height: "400px", width: "100%" },
                        attrs: {
                          value: _vm.customerQantityProductModal.barData,
                          text: _vm.customerQantityProductModal.barTitle,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }